export const WECHAT_VERIFY_ERROR = {
  E0010221: '请使用本人微信扫码',
};

export const ENTERPRISE_LOGIN_TYPE = 'sso';
